import React from 'react';
import { DashboardProvider, useDashboard } from './DashboardContext';

import DashboardHeader from './components/DashboardHeader';
import InstituteSelectors from './components/InstituteSelectors';
import FilterBar from './components/FilterBar';
import InsightBanner from './components/InsightBanner';
import SummaryCards from './components/SummaryCards';
import CampaignActivity from './components/CampaignActivity';
import EventActivity from './components/EventActivity';
import OtherActivityGrid from './components/OtherActivityGrid';
import MostActiveAlumni from './components/MostActiveAlumni';
import AlumniContributions from './components/AlumniContributions';

const periodLabels: Record<string, string> = {
    monthly: 'This Month',
    quarterly: 'This Quarter',
    halfyearly: 'This Half-Year',
    annual: 'This Year',
};

const DashboardContent: React.FC = () => {
    const { instituteLoaded, timeframe, setTimeframe } = useDashboard();

    return (
        <div className="main flex-1 bg-lighter-blue p-3 p-md-4">
            <div className="max-1140 mx-auto">
                <DashboardHeader />

                <InstituteSelectors
                    timeframe={timeframe}
                    setTimeframe={setTimeframe}
                />

                {!instituteLoaded ? (
                    <div className="text-center py-5 text-muted">
                        <i className="bi bi-buildings fs-1 d-block mb-3 opacity-25"></i>
                        <p className="font-16">Select an institute above to load dashboard data</p>
                    </div>
                ) : (
                    <>
                        <FilterBar periodLabel={periodLabels[timeframe]} />
                        <InsightBanner />
                        <SummaryCards compareMode={false} prevPeriodLabel="" />
                        <CampaignActivity compareMode={false} prevPeriodLabel="" />
                        <EventActivity />
                        <OtherActivityGrid compareMode={false} />

                        <div className="row g-3 mb-4">
                            <div className="col-lg-6">
                                <MostActiveAlumni />
                            </div>
                            <div className="col-lg-6">
                                <AlumniContributions compareMode={false} prevPeriodLabel="" />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const AlumniActivityDashboard: React.FC = () => (
    <DashboardProvider>
        <DashboardContent />
    </DashboardProvider>
);

export default AlumniActivityDashboard;
